import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  enabled: false,
  start: null,
  end: null,
  retryAfterSeconds: 3600,
  message: '',
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')
    systemSettingApi.getMaintenanceSetting()
      .then(({ data }) => commit('MAINTENANCE_SETTING_FETCHED', data))
      .catch(err => commit('MAINTENANCE_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateMaintenanceSetting(state)
      .then(({ data }) => commit('MAINTENANCE_SETTING_UPDATED', data))
      .catch(error => {
        commit('MAINTENANCE_SETTING_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  MAINTENANCE_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  MAINTENANCE_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  MAINTENANCE_SETTING_FETCHED(state, data) {
    const trimDate = value => (value ? value.slice(0, 16) : null)
    Object.assign(state, data, {
      start: trimDate(data.start),
      end: trimDate(data.end),
    })
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
